import * as Sentry from '@sentry/react';

/**
 * Componente para testar integração com Sentry
 * Remova ou oculte em produção
 */
export function SentryTestButton() {
  const testError = () => {
    try {
      throw new Error('Teste do Sentry - Erro capturado manualmente');
    } catch (error) {
      Sentry.captureException(error);
      alert('Erro enviado para Sentry! Verifique o dashboard.');
    }
  };

  const testUncaughtError = () => {
    throw new Error('Teste do Sentry - Erro não capturado (vai travar a aplicação)');
  };

  const testMessage = () => {
    Sentry.captureMessage('Mensagem de teste do Sentry', 'info');
    alert('Mensagem enviada para Sentry!');
  };

  // Só mostra em desenvolvimento
  if (import.meta.env.PROD) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white p-4 rounded-lg shadow-lg border-2 border-purple-500 z-50">
      <p className="text-sm font-bold text-purple-600 mb-2">🐛 Sentry Test</p>
      <div className="flex flex-col gap-2">
        <button
          onClick={testError}
          className="px-3 py-1 bg-yellow-500 text-white text-xs rounded hover:bg-yellow-600"
        >
          Erro Capturado
        </button>
        <button
          onClick={testUncaughtError}
          className="px-3 py-1 bg-red-500 text-white text-xs rounded hover:bg-red-600"
        >
          Erro Não Capturado
        </button>
        <button
          onClick={testMessage}
          className="px-3 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600"
        >
          Mensagem Info
        </button>
      </div>
    </div>
  );
}
